import { Injectable } from '@angular/core';
import { HttpClientService } from 'src/app/common/services/http-client-service';
import { ApiNameList } from 'src/environments/api-name-list';

@Injectable()
export class FilesService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }
    deleteFile(request: {fileId: number}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.deleteFile, request);
    }
    getFiles() {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getFiles,{});
    }
    uploadFile(request: any) {
        return this.httpClientService.postNodeApiFormData(this.baseUrl + ApiNameList.restApi.uploadFile,  request);
    }
    downloadFile(request: {fileId: number}) {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.downloadFile, request);
    }
    getFileLabelFormat() {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getFileLabelFormat, { label: "waiver_file_name" });
    }
}
